var Backbone = require('backbone')
var Config = require('config')
var App = require('app')
var BaseModel = require('src/common/base-model')
var BaseCollection = require('src/common/base-collection')
var _ = require('lodash')

var Clients = function () {
  var cached = {}

  // init
  var Client = BaseModel.extend({
    urlRoot: Config.api.host + '/clients',
    idAttribute: '_id',
    defaults: {
      warehouse: false,
      settings: {
        pricePerKwh: 0,
        prevKwhYear: 0,
        operatingTimes: {
          startTime: null,
          endTime: null
        },
        emergency: {
          flashDurationOn: 3,
          flashDurationOff: 3,
          fadeTime: 0
        }
      }
    },
    validation: {
      name: {
        required: true
      }
    },
    removePreset: function (id, options) {
      if (!options) options = {}
      options['patch'] = true
      var presets = this.get('presets')

      _.remove(presets, function (preset) {
        return preset._id === id
      })
      this.save({'presets': presets}, options)
    },
    addPreset: function (preset, options) {
      if (!options) options = {}
      options['patch'] = true
      this.save({'presets': this.get('presets').concat([preset])}, options)
    }
  })

  var ClientsCollection = BaseCollection.extend({
    url: Config.api.host + '/clients',
    idAttribute: '_id',
    model: Client,
    pageSize: 50
    // parse: function (data) {
    //   if (!data.data) return data
    //   return data.data
    // }

  })

  // //
  var API = {
    getClientEntitiesCached: function () {
      if (!cached.clients) cached['clients'] = API.getClientEntities({pagination: false})
      return cached.clients
    },
    getClientEntities: function (options) {
      let self = this

      var fetchParams = {
        reset: true,
        cache: true,
        prefill: true,
        expires: false
      }

      if (options) {
        if (options.query) fetchParams.data = options.query
      }

      var clients = new ClientsCollection([], options)

      // flush the cached entities
      clients.on('change add remove', () => {
        cached.clients = false
        API.getClientEntitiesCached()
      }, self)

      clients.fetch(fetchParams)
      return clients
    },
    getClientEntity: function (id) {
      var client = new Client({_id: id})
      client.fetch()
      return client
    },
    newClientEntity: function () {
      return new Client()
    },
    initialize: function (callback) {
      var clients = new ClientsCollection([], {pagination: false})
      clients.fetch({
        reset: true,
        success: function () {
          return callback(null)
        },
        error: function () {
          return callback(new Error('Something'))
        }
      })
      cached.clients = clients
    }
  }

  // Listeners
  App.globalChannel.reply({
    'client:entities:cached': API.getClientEntitiesCached,
    'client:entities': API.getClientEntities,
    'client:entity': API.getClientEntity
  })

  App.globalChannel.reply('client:entity:new', function () {
    return API.newClientEntity()
  })

  // Init
  return API
//
}

module.exports = Clients



// WEBPACK FOOTER //
// ./js/entities/clients.js